import { baseUrl } from './general-api';

export interface SocialMediaResponse {
    date: Date;
    picture: string;
    postId: string;
    attachments: string;
    permalinkUrl: string;
    from: string;
    shares: number;
    likes: number;
    comments: number;
}

/**
 * Base URL for the Social media API.
 */
export const socialMediaEndpoint = baseUrl + '/.rest/delivery/v1/social-media';

export const getSocialMediaPosts = (): Promise<SocialMediaResponse[]> => {
    const url = `${socialMediaEndpoint}`;

    return fetch(url)
        .then((response) => response.json())
        .then((data) => {
            return data.results;
        })
        .catch(() => {
            return [];
        });
};
